import React from "react";
import { useTranslation } from "react-i18next";
import { Colors, isDark } from "../../../../utils/style/colors";
import * as styles from "../style";
import { getAppTiles } from "../tiles";

const icons = require("../../../../utils/icons");

// Pure visual renderer for a single App-page tile. Used both inside the phone
// grid and as the live drawer preview. `children` carries the edit/delete dots
// (and react-grid-layout's resize handle) and must be rendered through.
const AppTile = React.forwardRef(({ type, config, children, ...other }, ref) => {
  const { t } = useTranslation();
  const cfg = config || {};
  const tile = getAppTiles(t).find((x) => x.type === type);
  if (!tile) return null;

  const showIcon = cfg.showIcon !== false;
  const Icon = icons[cfg.icon || tile.icon];
  const bgColor = cfg.bgColor || Colors.white;
  const ribbonColor = cfg.ribbonColor || tile.color || Colors.gray30;

  return (
    <styles.TileBox ref={ref} bgColor={bgColor} {...other}>
      {children}
      {showIcon && Icon && (
        <styles.TileIcon color={ribbonColor}>
          <Icon
            size={1.2}
            color={isDark(ribbonColor) ? Colors.white : Colors.gray60}
          />
        </styles.TileIcon>
      )}
      <styles.TileLabel bgColor={bgColor}>
        {cfg.text || tile.title}
      </styles.TileLabel>
    </styles.TileBox>
  );
});

export default AppTile;
